import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import SignKeyForm from '@containers/auth/SignKeyForm';
import ReadKeyRelease from '@containers/auth/ReadKeyRelease';

import { BookingSelectors } from '@redux/BookingRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import AppActions from '@redux/AppRedux';

function KeyRelease(props) {
  const { onSubmit, user, updatePropertyInfo, propertyID } = props;
  const [screenType, changeScreenType] = useState('signer');

  const handleViewKey = () => {
    changeScreenType('reader');
  };

  const handleDone = () => {
    changeScreenType('signer');
  };

  const handleOnOk = (signature, isSigned) => {
    if (isSigned) {
      updatePropertyInfo(propertyID, {
        signature,
        isKeyReleaseSigned: true
      });
    }
    onSubmit(signature);
  };

  const renderScreen = type => {
    switch (type) {
      case 'signer':
        return (
          <Box display="flex" flexDirection="column">
            <Heading>Accessing Your Apartment</Heading>
            <SignKeyForm
              propertyID={propertyID}
              user={user}
              onSubmit={handleOnOk}
              onViewKey={handleViewKey}
            />
          </Box>
        );

      case 'reader':
        return <ReadKeyRelease propertyID={propertyID} onSubmit={handleDone} />;
    }
  };

  return <MobileContainer>{renderScreen(screenType)}</MobileContainer>;
}

KeyRelease.propTypes = {
  user: PropTypes.object,
  isKeyReleaseSigned: PropTypes.bool,
  propertyID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSubmit: PropTypes.func,
  updatePropertyInfo: PropTypes.func
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state),
  propertyID: BookingSelectors.selectCurrentPropertyId(state)
});

const mapDispatchToProps = dispatch => ({
  updatePropertyInfo: (propertyId, info) =>
    dispatch(AppActions.setAppDataUpdatePropertyInfo(propertyId, info))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(KeyRelease);
